import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "app-helicopters-delete-document-dialog",
    templateUrl: "./helicopters-delete-document-dialog.component.html",
    styleUrl: "./helicopters-delete-document-dialog.component.scss",
    standalone: false,
})
export class HelicoptersDeleteDocumentDialogComponent {
    constructor(
        private dialogRef: MatDialogRef<HelicoptersDeleteDocumentDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { fileName: string },
    ) {}

    onConfirm() {
        this.dialogRef.close(true);
    }

    onCancel() {
        this.dialogRef.close(false);
    }
}
